"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelPromise = cancelPromise;
exports.withAbortSignal = withAbortSignal;
/**
 * wrap a promise with an abort signal,
 * used for request canceling with react-query
 * @param getPromise
 */
function withAbortSignal(getPromise) {
  // Create a new AbortController instance for this request
  var controller = new AbortController();
  // Get the abortController's signal
  var signal = controller.signal;
  var promise = getPromise(signal);
  // Cancel the request if React Query calls the `promise.cancel` method
  promise.cancel = function () {
    return controller.abort();
  };
  return promise;
}
function cancelPromise(p, signal) {
  signal === null || signal === void 0 || signal.addEventListener("abort", function () {
    p.cancel();
  });
  return p;
}